// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"64a72aa36ed58e80d2a3","524":"b0890b0baa81d6a179a5","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};